<template>
  <div class="page-content">
    <div class="content">
      <h1 class="page-title">{{ $t('dynamic.title') }}</h1>
      <div class="intro-section">
        <img
          src="../assets/img/shichangtuiguang.png"
          alt="动态推广"
          class="section-image"
        />
        <div class="article">
          <p>{{ $t('dynamic.intro') }}</p>
          <div class="promotion-features">
            <div class="promotion-item">
              <h3>{{ $t('dynamic.feature1.title') }}</h3>
              <p>{{ $t('dynamic.feature1.content') }}</p>
            </div>
            <div class="promotion-item">
              <h3>{{ $t('dynamic.feature2.title') }}</h3>
              <p>{{ $t('dynamic.feature2.content') }}</p>
            </div>
            <div class="promotion-item">
              <h3>{{ $t('dynamic.feature3.title') }}</h3>
              <p>{{ $t('dynamic.feature3.content') }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Dynamic',
  mounted() {
    // 监听语言切换事件
    this.$root.$on('language-changed', () => {
      this.$forceUpdate();
    });
  },
  beforeDestroy() {
    this.$root.$off('language-changed');
  },
};
</script>

<style scoped>
.page-content {
  min-height: calc(100vh - 160px);
  width: 100%;
  padding: 0;
  background: var(--bg-primary);
}

.content {
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 30px 15px;
  background: var(--bg-primary);
}

.page-title {
  font-size: 42px;
  line-height: 56px;
  font-weight: 700;
  color: var(--text-primary);
  text-align: center;
  margin-bottom: 50px;
  padding-bottom: 20px;
  border-bottom: 3px solid var(--accent-primary);
}

.intro-section {
  margin-top: 30px;
}

.section-image {
  width: 100%;
  max-width: 100%;
  display: block;
  margin: 0 auto 40px;
}

.article {
  font-size: 18px;
  line-height: 36px;
  color: var(--text-secondary);
  text-align: justify;
  padding: 0 10px 30px;
  width: 100%;
}

.article p {
  margin-bottom: 20px;
}

.promotion-features {
  margin-top: 40px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
}

.promotion-item {
  padding: 30px;
  background: var(--bg-card);
  border-radius: 8px;
  border-left: 4px solid var(--accent-primary);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.promotion-item:hover {
  transform: translateY(-5px);
  box-shadow: var(--shadow-lg);
  background: var(--bg-card-hover);
}

.promotion-item h3 {
  font-size: 24px;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 15px;
}

.promotion-item p {
  margin-bottom: 0;
  line-height: 28px;
  color: var(--text-secondary);
}

@media (max-width: 768px) {
  .content {
    width: 100%;
    padding: 20px 15px;
  }

  .page-title {
    font-size: 28px;
    line-height: 36px;
  }

  .article {
    font-size: 16px;
    line-height: 28px;
    padding: 0 10px 20px;
  }

  .promotion-features {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .promotion-item {
    padding: 20px;
  }

  .promotion-item h3 {
    font-size: 20px;
  }
}
</style>
